import * as _ from 'underscore';
import { ListResult } from '../fetchers/ListResult';
import { Filter } from '../helpers/Filter';
import { RequestHelper } from '../helpers/RequestHelper';
import { ResultHelper } from '../helpers/ResultHelper';
import { SliceableHelper } from '../helpers/SliceableHelper';
import { Module } from '../Module';
import {
  CheckUserNamesRequest,
  ICheckUserNamesResult,
} from '../ServerApi/requests/CheckUserNamesRequest';
import { GetUsersRequest, IGetUsersResult } from '../ServerApi/requests/GetUsersRequest';
import { FilterFieldNames, IStringArrayValuedFieldFilterClause } from '../ServerApi/types/IFilterClause';
import { SiteRoles } from '../ServerApi/types/ISiteRole';
import { IUser } from '../ServerApi/types/IUser';
import { FetcherFactory } from '../services/FetcherFactory';
import { ServerService } from '../services/ServerService';
import { Resource } from './Resource';
import { SiteRolesResource } from './SiteRoles';

export class Users extends Resource<IUser> {

  public AdminsOnlyFilter: IStringArrayValuedFieldFilterClause = Filter.stringFieldInArray(FilterFieldNames.siteRole, this.siteRoles.getAdminRoles());

  public CanOwnProjectFilter: IStringArrayValuedFieldFilterClause = Filter.stringFieldInArray(FilterFieldNames.siteRole, this.siteRoles.getProjectOwnershipRoles());

  public WithoutGuestFilter: IStringArrayValuedFieldFilterClause = Filter.stringFieldInArray(FilterFieldNames.siteRole,
    _.without(this.siteRoles.allOptions(), SiteRoles.Guest, SiteRoles.Unlicensed)
  );

  public static $inject = [
    'ServerService',
    'FetcherFactory',
    'SiteRoles'
  ];

  constructor(
    private server: ServerService,
    FetcherFactory: FetcherFactory,
    private siteRoles: SiteRolesResource
  ) {
    super(FetcherFactory.getServerResourceFetcher(
      GetUsersRequest,
      (result: IGetUsersResult) => result.users));
  }

  public checkUserNames(usernames: string[]): ng.IPromise<ICheckUserNamesResult> {
    return this.server.sendRequests(
      RequestHelper.buildRequests(usernames,
        (usernamesBlock) => new CheckUserNamesRequest({ usernames: usernamesBlock })),
      (results: ICheckUserNamesResult[]) => {
        return {
          errors: ResultHelper.combineErrors(results),
          users: ResultHelper.combine(results, (result) => result.users)
        };
      });
  }

  public getUsersById(userIds: string[]): ng.IPromise<ListResult<IUser>> {
    return SliceableHelper.fetchAll(this.all()
      .addFilter(Filter.stringFieldInArray('id', userIds)));
  }

  // gets the user with the specified username & domainName.
  public getUserByUsernameAndDomain(username: string, domainName: string): ng.IPromise<any> {
    return this.all()
      .addFilter(Filter.stringFieldEq('username', username))
      .addFilter(Filter.stringFieldEq('domainName', domainName))
      .getFirst();
  }

}

Module.instance().service('Users', Users);
